import React from 'react';
import { BRAND_FULL_NAME } from '../../config/brand';
import HomeSectionFrame from './HomeSectionFrame';

const advantages = [
  {
    id: '01',
    title: 'جودة تعليم عالية',
    description: 'تقديم أعلى جودة تعليمية لطلاب الثانوية في اللغة الإنجليزية.',
  },
  {
    id: '02',
    title: 'شرح مبسّط وواضح',
    description: 'فيديوهات مرتّبة بتوصّلك المعلومة بطريقة سهلة من غير تعقيد.',
  },
  {
    id: '03',
    title: 'تنظيم واضح للكورسات',
    description: 'كورسات مرتّبة حسب الصف والترم، عشان تلاقي اللي محتاجه بسهولة.',
  },
  {
    id: '04',
    title: 'امتحانات وتقييم مستمر',
    description: 'امتحانات إلكترونية بتساعدك تقيّم نفسك وتصلح أخطائك أول بأول.',
  },
];

const WhyChooseBanner: React.FC = () => (
  <HomeSectionFrame id="why-choose-section" aria-labelledby="platform-advantages-heading" tone="mist">
    <div className="mb-8 max-w-2xl sm:mb-10">
      <div className="mb-3 flex items-center gap-2.5">
        <span className="inline-block h-5 w-1 shrink-0 rounded-full bg-brand-500" aria-hidden />
        <p className="text-sm font-semibold text-brand-600">ليه المنصة دي؟</p>
      </div>
      <h2
        id="platform-advantages-heading"
        className="text-[clamp(1.6rem,1.5vw+1.1rem,2.35rem)] font-extrabold leading-snug text-slate-900"
      >
        ليه تختار {BRAND_FULL_NAME}؟
      </h2>
      <p className="mt-3 max-w-[42ch] text-sm leading-relaxed text-slate-600 sm:text-base sm:leading-7">
        مميزات واضحة بتساعدك تذاكر أوضح وأسهل من أول خطوة.
      </p>
    </div>

    <ol className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
      {advantages.map((item) => (
        <li key={item.id}>
          <article className="flex h-full flex-col rounded-2xl border-2 border-brand-100 bg-white p-5 transition hover:border-brand-300 hover:shadow-md sm:p-6">
            <span className="mb-3 text-sm font-bold text-brand-600">{item.id}</span>
            <h3 className="text-lg font-bold text-slate-900 sm:text-xl">{item.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600 sm:leading-7">
              {item.description}
            </p>
          </article>
        </li>
      ))}
    </ol>
  </HomeSectionFrame>
);

export default WhyChooseBanner;
